import { GearItemCard } from '../../../Cards/GearItemCard/GearItemCard';
import { CatchGearItem } from '../../types/CatchGearItem';

interface CatchGearCardsProps {
  postId: string;
  postGear: CatchGearItem[];
}

export const PostGearCards = ({ postId, postGear }: CatchGearCardsProps) => {
  return (
    <div>
      {postGear.map(({ product: { _id, brand, image, displayName } }, index) => (
        <GearItemCard
          key={`catch-gear-${postId}-${_id}-${index}`}
          brand={brand.name}
          image={image}
          name={displayName ?? ''}
        />
      ))}
    </div>
  );
};
